import React from 'react'
import "./styles/about.css" 

export default function About() {
    return (
        <section id="about" className="section">
            <h1>About Me {"{"}</h1>
            <div className="about-container">
                <div id="about-left-container">
                    <p>BCIT CST graduate that loves computers and tinkering way too much.
                    <br></br>
                    I also loooooooove cars and games.
                    </p>
                    <figure>
                        <img src="/car.jpg" alt="Blue car" id="car"></img>
                        <figcaption>This is my 2006 Acura RSX by the way.. <span>{"(📸 @pmokk on Instagram)"}</span></figcaption>
                    </figure>
                </div>
                <p> Driven by a passion for computer sciences for over a decade, I have spent years refining my skills through formal education and side projects.
                    <br></br>
                    <br></br>
                    My love for computers and technology has grown into a hunger for continuous learning and being better than I was yesterday.
                    <br></br>
                    <br></br>
                    Moments are more enjoyable with others. In my pursuit for knowledge in the tech space, I learn and continue to build on my skills as a team player.
                </p>
            </div>
            <h1> {"}"} </h1>
        </section>
    );
}